import Immutable from 'immutable';
const baseUrl = process.env.REACT_APP_BACKEND_URL;
export default {
};



// WEBPACK FOOTER //
// ./src/config/api.jsx